import PropTypes from 'prop-types';
import { Loader2 } from 'lucide-react';
import { Button } from 'src/features/tyre-management/components/ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from 'src/features/tyre-management/components/ui/dialog';

const ExportDialog = ({
  open, count, exporting, onClose, onConfirm,
}) => (
  <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && !exporting && onClose()}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Export matching vehicles?</DialogTitle>
        <DialogDescription>
          {`This download includes all ${count} vehicles that match the current search, filters, and order.`}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter>
        <Button type="button" variant="outline" disabled={exporting} onClick={onClose}>Cancel</Button>
        <Button type="button" disabled={exporting} onClick={onConfirm}>
          {exporting && <Loader2 className="h-4 w-4 animate-spin" />}
          {exporting ? 'Exporting…' : 'Export'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

ExportDialog.propTypes = {
  open: PropTypes.bool,
  count: PropTypes.number,
  exporting: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ExportDialog;
